/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "devicesettings": {
        "nested": {
          "ProductType": {
            "values": {
              "UNKNOWN": 1,
              "REGISTER": 2,
              "RESTAURANT": 3,
              "RETAIL": 4,
              "PAY_SDK": 5,
              "TERMINAL_API": 6,
              "KDS": 7,
              "KDS_EXPO": 8,
              "RESTAURANT_MOBILE": 9,
              "FNBKIOSK": 10,
              "INVOICES": 11,
              "APPOINTMENTS": 12,
              "KIOSK": 13,
              "SQUID_KIOSK": 14
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.devicesettings?.nested?.ProductType) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE ProductType @ squareup/devicesettings/product_type.proto at 11:1
 */
export const ProductType = $root.lookupEnum('squareup.devicesettings.ProductType').values;